module.exports = __webpack_public_path__ + "static/media/preplay-session-icon.ac57547c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-session-icon.svg
// module id = ./src/assets/images/preplay-session-icon.svg
// module chunks = 0